import { supabase } from './supabase';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Invia una notifica push reale (funziona anche ad app chiusa)
export async function sendPushNotification({ userId, title, body, url, tag }) {
  try {
    await fetch(`${SUPABASE_URL}/functions/v1/bright-api`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'apikey': SUPABASE_ANON_KEY,
        'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
      },
      body: JSON.stringify({ user_id: userId, title, body, url, tag }),
    });
  } catch (e) {
    console.error('Errore invio notifica push:', e);
  }
}

// Registra una notifica "in-app" per alimentare il pallino rosso sul Profilo
// (usata solo per eventi che non generano già un messaggio in chat: recensioni, verifica identità)
export async function logNotification({ userId, type, title, body, url }) {
  try {
    await supabase.from('notifications').insert({ user_id: userId, type, title, body, url });
  } catch (e) {
    console.error('Errore salvataggio notifica:', e);
  }
}